module.exports = __webpack_public_path__ + "img/bottom_bg.8dded7a5.png";